/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Spec_DeveloperInputs */

const en_fc_home_spec_developer = /** @type {(inputs: Fc_Home_Spec_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer`)
};

/**
* | output |
* | --- |
* | "Developer" |
*
* @param {Fc_Home_Spec_DeveloperInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_spec_developer = /** @type {((inputs?: Fc_Home_Spec_DeveloperInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Spec_DeveloperInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_spec_developer(inputs)
});
export { fc_home_spec_developer as "fc.home.spec.developer" }